import { createContext, useState, useContext, useRef } from "react";

const SlideContext = createContext();

export const useSlideContext = () => useContext(SlideContext);

export const SlideContextProvider = ({ children }) => {
  const [activeSlideTitle, setActiveSlideTitle] = useState("");
  const [modifiedSlideTitle, setModifiedSlideTitle] = useState(false);
  const [activeSlideLayout, setActiveSlideLayout] = useState('');
  const [hasPresentationAudio, setHasPresentationAudio] = useState(false);
  const [hasSlideAudio, setHasSlideAudio] = useState(false);
  const [selectedBlockCount, setSelectedBlockCount] = useState(0);
  const [selectedGroupCount, setSelectedGroupCount] = useState(0);
  const [selectModeStatus, setSelectModeStatus] = useState(false);
  const [blockOutlines, setBlockOutlines] = useState(false);
  const [showBlockTree, setShowBlockTree] = useState(false);
  const [activeSlideGrid, setActiveSlideGrid] = useState(false);
  const [hoveredNode, setHoveredNode] = useState(null);

  const currentEditorInstanceRef = useRef(null);
  const currentSlideRef = useRef(null);
  const toggleGridFunctionRef = useRef(null);
  const modifySlideTitleFunctionRef = useRef(null);
  const toggleSelectFunctionRef = useRef(false);
  const groupFunctionRef = useRef(null);
  const ungroupFunctionRef = useRef(null);
  const blockOutlinesFuncitonRef = useRef(null);
  const blockTreeUpdateFunctionRef = useRef(null);
  const blockOrderFunctionRef = useRef(null);

  // Registers
  const registerToggleGridFunction = (fn) => {
    toggleGridFunctionRef.current = fn;
  }

  const registerModifySlideTitle = (fn) => {
    modifySlideTitleFunctionRef.current = fn;
  }

  const registerToggleSelectFunction = (fn) => {
    toggleSelectFunctionRef.current = fn;
  }

  const registerGroupFunction = (fn) => {
    groupFunctionRef.current = fn;
  }

  const registerUngroupFunction = (fn) => {
    ungroupFunctionRef.current = fn;
  }

  const registerToggleBlockOutlinesFunction = (fn) => {
    blockOutlinesFuncitonRef.current = fn;
  }

  const registerCurrentEditorInstance = (editorInstance) => {
    currentEditorInstanceRef.current = editorInstance;
  }

  const registerCurrentSlideRef = (slideRef) => {
    currentSlideRef.current = slideRef;
  }

  const registerBlockTreeUpdateFunction = (fn) => {
    blockTreeUpdateFunctionRef.current = fn;
  }

  const registerBlockOrderFunction = (fn) => {
    blockOrderFunctionRef.current = fn;
  }
  

// Triggers
  const triggerToggleGrid = () => {
    if (toggleGridFunctionRef.current) {
      toggleGridFunctionRef.current();
    }
  }

  const triggerModifySlideTitle = (value) => {
    if (modifySlideTitleFunctionRef.current) {
      modifySlideTitleFunctionRef.current(value);
    }
  }
  
  const triggerToggleSelect = () => {
    if(toggleSelectFunctionRef.current){
      toggleSelectFunctionRef.current();
    }
  }

  const triggerGroup = () => {
    if(groupFunctionRef.current){
      groupFunctionRef.current();
    }
  }

  const triggerUngroup = () => {
    if(ungroupFunctionRef.current){
      ungroupFunctionRef.current();
    }
  }

  const triggerBlockOutlines = () => {
    if(blockOutlinesFuncitonRef.current){
      blockOutlinesFuncitonRef.current();
    }
  }

  const triggerBlockTreeUpdate = () => {
    if(blockTreeUpdateFunctionRef.current){
      blockTreeUpdateFunctionRef.current();
    }
  }

  const triggerBlockOrder = (value) => {
    if(blockOrderFunctionRef.current){
      blockOrderFunctionRef.current(value);
    }
  }

  return (
    <SlideContext.Provider
      value={{
        activeSlideTitle, setActiveSlideTitle,
        modifiedSlideTitle, setModifiedSlideTitle,
        activeSlideLayout, setActiveSlideLayout,
        hasSlideAudio, setHasSlideAudio,
        selectedBlockCount, setSelectedBlockCount,
        selectedGroupCount, setSelectedGroupCount,
        selectModeStatus, setSelectModeStatus,
        blockOutlines, setBlockOutlines,
        showBlockTree, setShowBlockTree,
        activeSlideGrid, setActiveSlideGrid,
        hoveredNode, setHoveredNode,
        registerToggleGridFunction,
        triggerToggleGrid,
        registerModifySlideTitle,
        triggerModifySlideTitle,
        registerToggleSelectFunction,
        triggerToggleSelect,
        registerGroupFunction,
        triggerGroup,
        registerUngroupFunction,
        triggerUngroup,
        registerToggleBlockOutlinesFunction,
        triggerBlockOutlines,
        registerCurrentEditorInstance,
        currentEditorInstanceRef,
        registerCurrentSlideRef,
        currentSlideRef,
        registerBlockTreeUpdateFunction,
        triggerBlockTreeUpdate,
        registerBlockOrderFunction,
        triggerBlockOrder,
      }}
    >
      {children}
    </SlideContext.Provider>
  );
}